<!--  -->
<template>
  <div class="stepper" v-if="cart"  v-on:click.stop.prevent>
    <div class="stepper-minus btn" @click="minus" :class="{'disabled-btn':disabledClick}"></div>
    <input class="stepper-num" type="number" @blur="changeNumber" v-model="cart.quantity" name="" id="">
    <div class="stepper-add btn" @click="add" :class="{'disabled-btn':disabledClick}"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NOTBULK, BULK } from '@/const/GoodsCount' // NOTBULK非散装 BULK散装
import { debounce, SessionStorage } from '@/utils'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
Vue.use(Toast)
export default {
  components: {},

  props: {
    value: {
      type: [Object, Array],
      default: () => null
    },
    disabledClick: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      cart: Array.isArray(this.value) ? this.value[0] : this.value,
      carts: this.value
    }
  },

  computed: {
    ...mapGetters(['getSelectIdents']),
    /**
     * @description 获取库存 promotion_stock:套装库存  hide_stock：其他商品库存
     */
    getStock () {
      const { cart } = this
      return cart.promotion_stock || cart.hide_stock
    },
    /**
     * @description 零库存是否可以购买
     * @returns 0 不可购买
     */
    getIsEmptyStock () {
      const { getLoadSettingStatus: { data } } = this
      return data.is_empty_stock
    },
    idents () {
      if (Array.isArray(this.carts)) {
        return this.carts.map(item => item.ident).join(',')
      } else {
        return this.carts.ident
      }
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        let value = JSON.parse(JSON.stringify(val))
        this.cart = Array.isArray(value) ? value[0] : value
        this.carts = value
      }
    },
    'cart.quantity' (newVal, oldVal) {
      if (this.$route.path === '/shopping-cart/presell') {
        const presell = SessionStorage.getItem('presell')
        presell.quantity = newVal
        SessionStorage.setItem('presell', presell)
      }
    }

  },

  created () {
  },

  methods: {
    /**
     * @description 处理小数加减浮点数问题
     * @param num
     * @returns {number}
     */
    handlerNumber (num) {
      return parseFloat(num.toFixed(10))
    },
    add: debounce(function () {
      const { cart, idents, handlerNumber } = this
      let num = 0
      if (!this.getSelectIdents.join(',').includes(cart.ident)) { // 如果没被选中不做处理
        Toast('请选中商品')
        return false
      }
      if (+cart.is_real_separate === 1) { // 如果是整件
        num = +cart.quantity + +cart.middle_pack_num
      } else if (cart.choose === 0) { // 非散装
        num = +cart.quantity + NOTBULK
      } else if (cart.choose === 1) { // 散装
        num = (+cart.quantity + BULK).toFixed(3)
      }
      if (num > this.getStock && this.getIsEmptyStock === 0) { // 如果数量大于库存并且不是零库存可以购买
        num = +cart.quantity
        Toast('抱歉，已超出商品库存')
        return false
      }
      cart.quantity = handlerNumber(+num)

      this.$emit('updateGoods', { num, pid: idents })
    }, 500),
    minus: debounce(function () {
      const { cart, idents, handlerNumber } = this
      let num = 0
      if (!this.getSelectIdents.join(',').includes(cart.ident)) { // 如果没被选中不做处理
        Toast('请选中商品')
        return false
      }
      if (+cart.is_real_separate === 1) { // 如果是整件
        num = +cart.quantity - +cart.middle_pack_num
        if (num < cart.middle_pack_num) {
          Toast('抱歉，不能低于0')
          return
        }
      } else if (cart.choose === 0) { // 非散装
        num = +cart.quantity - NOTBULK
        if (num < NOTBULK) {
          Toast('抱歉，不能低于0')
          return
        }
      } else if (cart.choose === 1) { // 散装
        num = (+cart.quantity - BULK).toFixed(3)
        if (num < BULK) {
          Toast('抱歉，不能低于0')
          return
        }
      }
      if (+num > +this.getStock && this.getIsEmptyStock === 0) { // 如果数量大于库存并且不是零库存可以购买
        num = +cart.quantity
        Toast('抱歉，已超出商品库存')
        return false
      }
      cart.quantity = handlerNumber(+num)
      this.$emit('updateGoods', { num, pid: idents })
    }, 300),
    changeNumber () {
      const { cart, idents } = this
      let reg = /^\d+$|^\d+[.]?\d+$/
      if (!reg.test(cart.quantity)) {
        if (+cart.choose === 0) {
          cart.quantity = NOTBULK
        } else {
          cart.quantity = BULK
        }
        return
      }
      if (+cart.quantity > +this.getStock && this.getIsEmptyStock === 0) {
        Toast('抱歉，已超出商品库存')
        cart.quantity = this.getStock
      }
      if (cart.quantity < 0) {
        Toast('抱歉，不能低于0')
        if (+cart.choose === 0) {
          cart.quantity = NOTBULK
        } else {
          cart.quantity = BULK
        }
      }

      if (+cart.choose === 0) {
        if (cart.quantity < 0) {
          cart.quantity = NOTBULK
        } else {
          cart.quantity = parseInt(cart.quantity)
        }
      } else {
        if (cart.quantity < 0) {
          cart.quantity = BULK
        } else {
          cart.quantity = (+cart.quantity).toFixed(3)
        }
      }
      this.$emit('updateGoods', { num: cart.quantity, pid: idents })
    }
  }
}

</script>
<style lang='scss' scoped>
.stepper{
  width: 78px;
  height: 24px;
  display: flex;
  .btn{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    box-sizing: border-box;
  }
  &-minus{
    border: 1px solid var(--APP_theme_color);
    background: rgba(255,255,255,1);
    @include center();
    &::before{
      content: '';
      display: inline-block;
      width: 11px;
      height: 2px;
      background: var(--APP_theme_color);
    }
  }
  &-num{
    border: none;
    display: inline-block;
    text-align: center;
    width: 30px;
  }
  &-add{
    border: 1px solid var(--APP_theme_color);
    background: var(--APP_theme_color);
    position: relative;
    /* @include center(); */
    &::before{
      content: '';
      display: inline-block;
      width: 11px;
      height: 2px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

    margin: auto;
      background: rgba(255,255,255,1);
    }
    &::after{
      content: '';
      display: inline-block;
      width: 2px;
      height: 11px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background: rgba(255,255,255,1);
    }
  }
}
.disabled-btn{
  pointer-events: none;
}
</style>
